import { render } from "./widget.vue?vue&type=template&id=33e91d6e&scoped=true"
import script from "./widget.vue?vue&type=script&lang=js"
export * from "./widget.vue?vue&type=script&lang=js"

import "./widget.vue?vue&type=style&index=0&id=33e91d6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e91d6e"]])

export default __exports__